<div class="component d-flex flex-column">
    <app-toolbar *ngIf="loggedIn()"></app-toolbar>
    <app-breadcrumb *ngIf="loggedIn()"></app-breadcrumb>
    <div class="content d-flex flex-column" role="main">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>
